import { getStoredAccessMode, isPremiumAccess } from "./accessMode";

const ADMIN_ACCESS_KEY = "tofu-awards-admin-access";

export const ADMIN_PASSWORD = "daniadministrador";

export const hasAdminAccess = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return sessionStorage.getItem(ADMIN_ACCESS_KEY) === "granted";
};

export const grantAdminAccess = () => {
  if (typeof window === "undefined") {
    return;
  }

  sessionStorage.setItem(ADMIN_ACCESS_KEY, "granted");
};

export const revokeAdminAccess = () => {
  if (typeof window === "undefined") {
    return;
  }

  sessionStorage.removeItem(ADMIN_ACCESS_KEY);
};

export const hasPremiumEditorAccess = () => isPremiumAccess(getStoredAccessMode());

export const canManageAdminPanel = () => hasAdminAccess() && hasPremiumEditorAccess();
